import { useTheme } from "@mui/system";

export default function ContactsIcon() {
  const theme = useTheme()
  return (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M4.75 12.5C3.36147 13.0294 2.5 13.7671 2.5 14.5831C2.5 16.1941 5.85787 17.5 10 17.5C14.1422 17.5 17.5 16.1941 17.5 14.5831C17.5 13.7671 16.6385 13.0294 15.25 12.5M10 7.5H10.0083M15 7.5C15 10.8864 11.25 12.5 10 15C8.75 12.5 5 10.8864 5 7.5C5 4.73857 7.23857 2.5 10 2.5C12.7614 2.5 15 4.73857 15 7.5ZM10.8333 7.5C10.8333 7.96023 10.4602 8.33333 10 8.33333C9.53975 8.33333 9.16667 7.96023 9.16667 7.5C9.16667 7.03977 9.53975 6.66667 10 6.66667C10.4602 6.66667 10.8333 7.03977 10.8333 7.5Z" 
      stroke={theme.palette.rgd.primary}
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
  )
}